<div>
    {{'LOADING'|translate}}
</div>